<template>
    <div class="cases-center" >
        <div class="cases-title">
            <canvas id="cases-title-canvas">
            </canvas>
            <h2>成功案例</h2>
        </div>
        <ul class="case-type">
            <li @mouseenter="mouseEnter(0)" 
                @mouseleave="mouseLeave"
                @click="caseType()"
                :class="{active: 0==enterIndex || 0==actIndex}"
            >
                全部
            </li>
            <li @mouseenter="mouseEnter(item.id)" 
                @mouseleave="mouseLeave"
                @click="caseType(item.name,item.id)"
                v-for="item in type"
                :key="item.id"
                :class="{active: item.id==enterIndex || item.id==actIndex}"
            >
                {{item.name}}
            </li>
        </ul>
        <div class="cases-swiper-container" ref="casesPages">
            <div class="swiper-wrapper">
                <div class="swiper-slide swiper-no-swiping cases-show" v-for="(page,index) in pages" :key="index" >
                    <ul>
                        <li @mouseenter="open(index*6+index2)" 
                            @mouseleave="close(index*6+index2)" 
                            v-for="(item,index2) in page" :key="item.id"
                            @click="link(item)">
                            <img :src="$imgUrl+item.photo" alt="">
                            <!--<transition>
                                <div v-show="index*6+index2 == actCase && item.code" class="abso">
                                    <img :src="$imgUrl+item.code" alt="">
                                </div>
                            </transition>-->
                            <transition>
                                <div v-show="index*6+index2 == actCase" class="abso">
                                    <img :src="$imgUrl+item.code" alt="" v-if="item.code">
                                    <p v-else><span>{{item.title}}</span></p>
                                </div>
                            </transition>
                            <!--<h4>{{item.title}}</h4{>
                            <span>{{getDate(item.date)}}</span>
                            <p v-html="item.content"></p>
                            <div @click="newsDetail(item.id)">查看详情<i class="iconfont icon-yousanjiaoxing"></i></div>-->
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="cases-button">
            <i class="cases-swiper-button-prev iconfont icon-jiantouzuo"></i><i class="cases-swiper-button-next iconfont icon-icon_arrow_right"></i>
        </div>
        <div class="cases-swiper-pagination"></div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'CasesCenter',
    props:{
        type: Array,
        cases: Array
    },
    mounted () {
        this.makeCanvas()
    },
    data () {
        return {
            actIndex: 0,
            enterIndex: -1,
            actCase: -1,
            caseData: [],
            caseArr: {},
        }
    },
    methods: {
        link (item) {
            // console.log(item)
            if(item.link != ''){
                // alert(item.link)
                // console.log(item.link)
                // console.log(1111111)
                // location.assgin(item.link)
                window.open(item.link,"_blank")
                // window.location.href = item.link
                // return 
            }
            else if(!item.code){
                this.$router.push('/casedetail/'+item.id)
            }
        },
        caseType (type,index) {
            if(type == null){
                this.caseData = this.caseArr.all
                this.actIndex = 0
            }else{
                // if(this.caseArr[type]==null) return 
                this.actIndex = index
                if(!this.caseArr[type]){
                    this.caseData = []
                }
                this.caseData = this.caseArr[type]
            }
        },
        caseTypeArr () {
            for(var i=0 ; i<this.cases.length ; i++){
                var type = this.cases[i].cate
                if(!this.caseArr[type]){
                    this.caseArr[type] = []
                }
                this.caseArr[type].push(this.cases[i])
            }
            this.caseArr.all = this.cases
        },
        open (id) {
            this.actCase = id;
            // this.$refs.casesPages.getElementsByTagName('li')[id].getElementsByTagName('div')[0].className = "highlight"
        },
        close (id) {
            this.actCase = -1;
            // this.$refs.casesPages.getElementsByTagName('li')[id].getElementsByTagName('div')[0].className = ""
        },
        mouseEnter (index) {
            this.enterIndex = index
        },
        mouseLeave () {
            this.enterIndex = -1
        },
        makeCanvas () {
            var canvas = document.getElementById('cases-title-canvas')
            var ctx = canvas.getContext('2d')
            canvas.width = document.body.clientWidth
            canvas.height = document.body.clientWidth * 0.16
            ctx.font = '800 120px "微软雅黑"'
            ctx.textBaseline = "middle"
            ctx.textAlign = "center"
            ctx.fillStyle = "#f0f0f0"
            ctx.fillText("PROJECTS",canvas.width * 0.5 , canvas.height * 0.52)
        },
        imgSwiper () {
            var swiper = new Swiper('.cases-swiper-container', {
                slidesPerView: 1,
                noSwiping : true,
                navigation: {
                    nextEl: '.cases-swiper-button-next',
                    prevEl: '.cases-swiper-button-prev',
                },
                pagination: {
                    el: '.cases-swiper-pagination',
                    type: 'fraction'
                },
                observer:true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents:false,//修改swiper的父元素时，自动初始化swiper
                onSlideChangeEnd: function(swiper){
                    swiper.update();  
                    mySwiper.startAutoplay();
                    mySwiper.reLoop();  
                }
                // autoHeight: true,
            });
        },
    },
    computed: {
        pages () {
            const pages = []
            if(!this.caseData) return pages
            this.caseData.forEach((item,index)=>{
                const page = Math.floor(index/12);
                if(!pages[page])
                    pages[page] = []
                pages[page].push(item)
            })
            return pages
        }
    },
    watch: {
        cases(newVal){
            this.caseData = newVal
            this.caseTypeArr()
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .cases-center >>> .swiper-button-disabled
                color: #999 !important
    .cases-center >>> .swiper-pagination-fraction
                color: #666 !important
    .cases-center
        box-sizing: border-box
        text-align: center
        width: 100%
        max-width: 1920px
        min-width: 1440px
        margin: 0 auto
        padding: 5% 3% 190px
        background: #fff
        .cases-title 
            position: relative
            #cases-title-canvas
                vertical-align: middle
            h2
                position: absolute
                font-size: 42px
                top: 50%
                left: 50%
                margin: -0.5em 0 0 -2em
                font-weight: 600
                letter-spacing: 2px
                color: #333
                &:after
                    content: ''
                    position: absolute
                    margin-left: -0.83em 
                    display: block
                    border-bottom: 1px solid #333
                    width: 72px
                    margin-top: 26px
                    left: 50%
        .case-type
            margin: 0 auto
            text-align: center
            li
                display: inline-block
                width: 8%
                line-height: 3.6em
                font-size: 14px
                cursor: pointer
                margin-right: 0.6%
                color: #000
                background: #ccc
                border-radius: 2px
            .active
                color: #fff
                background: $black    
        .cases-swiper-container
            overflow: hidden
            .cases-show
                box-sizing: border-box
                width: 100%
                padding: 0 2%
                margin-top: 70px
                overflow: hidden
                li
                    position:relative
                    width: 32%
                    float: left
                    margin: 0 2% 2% 0
                    background: #fff
                    padding-bottom: 22.8%
                    overflow: hidden
                    img
                        position: absolute
                        top: 0
                        left: 0
                        width: 100%
                        vertical-align: middle
                        cursor: pointer
                        height: 100%
                li:nth-of-type(3n)
                    margin-right: 0
                .abso
                    position: absolute
                    top: 0
                    bottom: 0 
                    left: 0
                    right: 0
                    width: 100%
                    background: $black
                    opacity: 0.9
                    img
                        position: absolute
                        width: 35%
                        right:0
                        left: 0
                        top: 0
                        bottom: 0
                        margin: auto
                        height: auto
                        cursor: default
                    p
                        position: absolute
                        width: 100%
                        top: 0 
                        bottom: 0
                        left: 0 
                        right: 0
                        margin: auto
                        font-size: 22px
                        color: $yellow
                        cursor: pointer
                        span
                            position: absolute
                            display: block
                            top: 0
                            bottom: 0 
                            left: 0
                            right: 0
                            margin: auto
                            height: 1em
                        &:before
                            position: absolute
                            display: block
                            content: ''
                            width: 6em
                            border-top: 1px solid $yellow
                            left: 7%
                            top: 50%
                        &:after
                            position: absolute
                            display: block
                            content: ''
                            width: 6em
                            border-top: 1px solid $yellow
                            right: 7%
                            top: 50%
        .cases-button
            display: inline-block
            margin: 82px auto 41px
            font-size: 14px
            background: #000
            line-height: 60px
            i
                color: #fff
                padding: 0 2.4em
                font-size: 12px
                cursor: pointer
                outline: none
</style>



// WEBPACK FOOTER //
// src/components/pc/CaseCenter.vue